const primaryAreas = [
  { city: "St. Mary's",            state: 'GA', primary: true,  zip: '31558' },
  { city: "King's Bay",            state: 'GA', primary: false, zip: '31547' },
  { city: 'Highland Oaks',         state: 'GA', primary: false, zip: '31558' },
  { city: 'Sugar Mill Plantation', state: 'GA', primary: false, zip: '31558' },
  { city: 'Kingsland',             state: 'GA', primary: false, zip: '31548' },
  { city: 'River Cove',            state: 'GA', primary: false, zip: '31558' },
  { city: 'Woodbine',              state: 'GA', primary: false, zip: '31569' },
  { city: 'White Oak',             state: 'GA', primary: false, zip: '31568' },
  { city: 'Homeland',              state: 'GA', primary: false, zip: '31537' },
];

const serviceCombos = [
  { city: "St. Mary's",     service: 'Wood Privacy Fence', icon: 'fa-tree' },
  { city: "King's Bay",     service: 'Chain-Link Security', icon: 'fa-link' },
  { city: 'Kingsland',      service: 'Vinyl Privacy Fence', icon: 'fa-border-all' },
  { city: 'Woodbine',       service: 'Ornamental Steel',    icon: 'fa-shield-halved' },
  { city: 'Highland Oaks',  service: 'Aluminum Fence',      icon: 'fa-award' },
  { city: 'Sugar Mill',     service: 'Custom Gates',        icon: 'fa-door-open' },
  { city: 'River Cove',     service: 'Board-on-Board Wood', icon: 'fa-tree' },
  { city: 'White Oak',      service: 'Steel Perimeter',     icon: 'fa-shield-halved' },
];

const ServiceAreasSection: React.FC = () => (
  <section className="relative bg-[#FAF8F5]">
    <div className="section-number right-6 top-8">03</div>

    <div className="section-py max-w-7xl mx-auto px-6 relative z-10">
      {/* Header */}
      <div className="text-center mb-16 reveal">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="gold-bar" />
          <span className="text-[#C4A84F] text-[11px] tracking-[0.38em] uppercase font-sans font-medium">
            Service Coverage
          </span>
          <span className="gold-bar" />
        </div>
        <h2 className="font-serif text-[3.2rem] md:text-[4.2rem] lg:text-[5rem] text-[#0D0C0B] leading-[0.95] mb-6">
          Proudly Serving St. Mary's<br />&amp; All of Camden County
        </h2>
        <p className="text-[#0D0C0B]/50 text-base leading-relaxed font-sans max-w-2xl mx-auto">
          Locally rooted for over 20 years — we know these communities because we live, work, and build fences here every day. Masters Fencing is Camden County's most trusted fencing contractor.
        </p>
      </div>

      {/* Two-column main layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start mb-14">
        {/* Left — cities + combos */}
        <div className="reveal-left">
          <h3 className="font-serif text-[1.8rem] text-[#0D0C0B] mb-7">Communities We Serve</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-12">
            {primaryAreas.map((area) => (
              <div
                key={area.city}
                className={`flex items-center gap-2.5 px-4 py-3.5 transition-all duration-200 group ${
                  area.primary
                    ? 'bg-[#0D0C0B] text-[#F5F1E8]'
                    : 'bg-white border border-[#0D0C0B]/8 hover:border-[#C4A84F]/50 hover:bg-[#FAF8F5]'
                }`}
              >
                <i className="fa-solid fa-location-dot text-[#C4A84F] text-[11px] shrink-0" />
                <div>
                  <div className={`text-sm font-medium font-sans leading-tight ${area.primary ? 'text-[#F5F1E8]' : 'text-[#0D0C0B]/80'}`}>
                    {area.city}
                  </div>
                  <div className={`text-[10px] font-sans ${area.primary ? 'text-[#C4A84F]' : 'text-[#0D0C0B]/35'}`}>
                    {area.state} · {area.zip}
                  </div>
                </div>
                {area.primary && (
                  <span className="ml-auto text-[8px] tracking-wider uppercase font-sans text-[#C4A84F] border border-[#C4A84F]/50 px-1.5 py-0.5 shrink-0">
                    HQ
                  </span>
                )}
              </div>
            ))}
          </div>

          <h3 className="font-serif text-[1.8rem] text-[#0D0C0B] mb-7">Popular Service + City Combinations</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
            {serviceCombos.map((c) => (
              <div key={`${c.city}-${c.service}`} className="flex items-center gap-3 bg-white border-l-2 border-[#C4A84F] px-4 py-3 hover:bg-[#F5F1E8] transition-colors">
                <i className={`fa-solid ${c.icon} text-[#C4A84F] text-xs shrink-0`} />
                <span className="text-sm font-sans text-[#0D0C0B]/70 leading-snug">
                  <strong className="text-[#0D0C0B] font-semibold">{c.service}</strong>
                  <br />
                  <span className="text-xs text-[#0D0C0B]/45">{c.city}, GA</span>
                </span>
              </div>
            ))}
          </div>

          <a
            href="tel:912-409-2031"
            className="inline-flex items-center gap-3 bg-[#0D0C0B] text-[#F5F1E8] text-[11px] font-bold tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#C4A84F] hover:text-[#0D0C0B] transition-all duration-300 whitespace-nowrap"
          >
            <i className="fa-solid fa-phone text-[10px]" />
            Confirm Your Area — 912-409-2031
          </a>
        </div>

        {/* Right — enlarged map */}
        <div className="reveal-right">
          <div className="overflow-hidden border border-[#0D0C0B]/8">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d111408.14!2d-81.6164476!3d30.863178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e503b1bb249029%3A0x9bb706a29a9493cf!2sMasters%20Fencing!5e0!3m2!1sen!2sus!4v1680000000000!5m2!1sen!2sus"
              width="100%"
              height="500"
              style={{ border: 0, display: 'block' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Masters Fencing location — St. Mary's Georgia"
            />
          </div>
          {/* Address bar */}
          <div className="bg-[#0D0C0B] px-7 py-5 flex items-center gap-5">
            <div className="w-11 h-11 flex items-center justify-center bg-[#C4A84F] shrink-0">
              <i className="fa-solid fa-location-dot text-[#0D0C0B] text-base" />
            </div>
            <div className="flex-1">
              <div className="text-[#F5F1E8] text-sm font-semibold font-sans">
                104 Admiral's Walk Dr, St. Marys, GA 31558
              </div>
              <div className="text-[#F5F1E8]/38 text-xs font-sans mt-0.5">
                Mon–Sat: 6:00 am–6:00 pm · Sunday: Closed
              </div>
            </div>
            <a
              href="https://www.google.com/maps/place/Masters+Fencing/@30.863178,-81.6164476,9z"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-[#C4A84F] text-xs font-sans hover:underline whitespace-nowrap shrink-0"
            >
              Directions <i className="fa-solid fa-arrow-up-right-from-square text-[10px] ml-0.5" />
            </a>
          </div>
        </div>
      </div>

      {/* Local authority strip */}
      <div className="bg-[#0D0C0B] p-8 md:p-10 reveal">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
          <div className="w-14 h-14 flex items-center justify-center shrink-0 border border-[#C4A84F]/30">
            <i className="fa-solid fa-map-location-dot text-2xl text-[#C4A84F]" />
          </div>
          <div>
            <strong className="font-serif text-[1.4rem] text-[#F5F1E8] block mb-2">
              Georgia's Southeast Coast — Our Home Territory
            </strong>
            <p className="text-[#F5F1E8]/45 text-sm font-sans leading-relaxed max-w-3xl">
              Based in St. Mary's at the southern tip of Georgia's Golden Isles coast, Masters Fencing serves Camden County's unique mix of coastal estates, military communities (King's Bay Naval Base), suburban neighborhoods, and rural properties. We understand the local terrain, humidity, soil conditions, and what property owners here truly need from a fence that lasts.
            </p>
          </div>
          <div className="md:ml-auto shrink-0">
            <a href="#estimate" className="btn-gold">
              <i className="fa-regular fa-calendar-check text-[11px]" />
              Get a Free Estimate
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ServiceAreasSection;
